<div class="card-header">
  <img width="275" height="100" class="card-image" ngSrc="./assets/images/netsmart-logo.png" alt="Netsmart logo" />
  <div class="image-border"></div>
</div>
